import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PATHS } from "../../../../constants";
import { useAppSelector } from "../../../../hooks/redux";
import { useAction } from "../../../../hooks/actions";

import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";

const stepForms = [FirstStep, SecondStep];

const AuthSteps = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { authStep } = useAppSelector((state) => state.logs);
  const { setAuthStep } = useAction();

  const CurrentStepForm = useMemo(() => stepForms[authStep], [authStep]);

  return (
    <>
      <Box>
        <Box display={"flex"} justifyContent={"center"}>
          {authStep == 1 && (
            <IconButton
              className="default-label-text"
              sx={{ p: 0, height: "24px", alignSelf: "center", mb: "20px" }}
              onClick={() => setAuthStep(0)}
              size="small"
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography className="login-title-auth" sx={{ mb: "16px" }} variant={"h4"} textAlign={"center"}>
            {t("label:authorization")}
          </Typography>
        </Box>

        {authStep == 0 && (
          <Typography textAlign={"center"} className="default-label-text">
            {t("label:logIntoAccount")}
          </Typography>
        )}
      </Box>

      <CurrentStepForm setAuthStep={setAuthStep} />

      {/* <Typography
        sx={{ fontWeight: "500", fontSize: "16px !important", mb: "0px !important" }}
        className="default-label-text"
      >
        {`${t("label:havingAccountQuestion")} `}
        <Typography component={"span"} className="btn btn-link" onClick={() => navigate(PATHS.REGISTRATION_ROUTE)}>
          {t("button:registrationRequest")}
        </Typography>
      </Typography> */}
    </>
  );
};

export default AuthSteps;
